import React, { useState, useMemo } from 'react';
import blogPosts from '../data/blogPosts';
import BlogHero from '../components/blog/BlogHero';
import BlogFilters from '../components/blog/BlogFilters';
import BlogFeaturedPost from '../components/blog/BlogFeaturedPost';
import BlogCard from '../components/blog/BlogCard';
import BlogNewsletter from '../components/blog/BlogNewsletter';
import BlogPostModal from '../components/blog/BlogPostModal';

const Blog = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedPost, setSelectedPost] = useState(null);

  const filteredPosts = useMemo(() => {
    const q = searchTerm.toLowerCase();
    return blogPosts.filter((post) => {
      const matchesCategory = selectedCategory === 'all' || post.category === selectedCategory;
      const matchesSearch =
        post.title.toLowerCase().includes(q) ||
        post.excerpt.toLowerCase().includes(q);
      return matchesCategory && matchesSearch;
    });
  }, [searchTerm, selectedCategory]);

  const featuredPost = blogPosts[0];
  const showFeatured = selectedCategory === 'all' && !searchTerm;

  return (
    <div className="min-h-screen pt-24">
      <BlogHero />

      <BlogFilters
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        selectedCategory={selectedCategory}
        onCategoryChange={setSelectedCategory}
      />

      {showFeatured && featuredPost && (
        <BlogFeaturedPost post={featuredPost} onOpen={setSelectedPost} />
      )}

      {/* Blog Posts Grid */}
      <section className="py-20 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-4 mb-16">
            <h2 className="text-4xl font-bold text-white">
              Latest
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500"> Articles</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.map((post) => (
              <BlogCard key={post.id} post={post} onOpen={setSelectedPost} />
            ))}
          </div>

          {filteredPosts.length === 0 && (
            <div className="text-center py-20">
              <div className="text-slate-400 text-xl mb-4">No articles found</div>
              <p className="text-slate-500">Try adjusting your search terms or filters</p>
            </div>
          )}
        </div>
      </section>

      <BlogNewsletter />

      <BlogPostModal post={selectedPost} onClose={() => setSelectedPost(null)} />
    </div>
  );
};

export default Blog;
